module.exports = __webpack_public_path__ + "img/logo-nobg.feac2c71.png";